module.exports = __webpack_public_path__ + "img/order+reservation.f047188d.png";